export enum Paths {
    Home = '/',
    LoginSignup = '/login-signup',
    FAQs = '/faqs',
    RegisterForPatent = '/register-for-patent',
    EducationalContent = '/educational-content',
    LocateNearestPatentOffice = '/locate-nearest-patent-office',
    allowAll = '*',
}